// Nutzungsarten mit optionalen Unterkategorien
export const USAGE_TYPES: Record<string, string[]> = {
  'Bildung': ['Grundschule', 'Gesamtschule', 'Weiterführende Schule', 'Berufsschule', 'Kita / Kindergarten', 'Universität', 'Fachhochschule', 'Sonstiges'],
  'Verwaltung': ['Rathaus', 'Behörde / Amt', 'Stadtwerke', 'Sonstiges'],
  'Sicherheit': ['Feuerwehr', 'Polizei', 'THW', 'Rettungsdienst', 'Sonstiges'],
  'Kultur': ['Museum', 'Bibliothek', 'Theater / Oper', 'Sakral', 'Denkmal', 'Sonstiges'],
  'Sportstätten': ['Turnhalle', 'Schwimmbad', 'Stadion', 'Sportplatz', 'Sonstiges'],
  'Soziales': ['Pflegeheim', 'Betreutes Wohnen', 'Flüchtlingsunterkunft', 'Sonstiges'],
  'Medizin': ['Krankenhaus', 'Ärztehaus', 'Praxis', 'Reha', 'Sonstiges'],
  'ÖPNV': ['Bahnhof', 'Busbahnhof', 'U-Bahn', 'Depot', 'Sonstiges'],
  'Wohnen': ['EFH', 'MFH', 'Hochhaus', 'Sonstiges'],
  'Gewerbe': ['Büro', 'Einzelhandel', 'Hotel', 'Gastronomie', 'Einkaufszentrum', 'Logistik', 'Sonstiges'],
  'Industrie': ['Produktion', 'Lager', 'Werkstatt', 'Sonstiges'],
  'Infrastruktur': ['Wasserwerk', 'Kläranlage', 'Umspannwerk', 'Rechenzentrum', 'Sonstiges'],
  'Friedhof': [],
  'Sonstiges': [],
}

// Gebäudetypen je Nutzungsart
export const BUILDING_TYPES_BY_USAGE: Record<string, string[]> = {
  'Bildung': ['Hauptgebäude', 'Nebengebäude', 'Turnhalle', 'Mensa', 'Fachklassentrakt', 'Aula', 'Verwaltungstrakt', 'WC', 'Hausmeister', 'Sonstiges'],
  'Verwaltung': ['Hauptgebäude', 'Nebengebäude', 'Archiv', 'Lager', 'Garage', 'Sonstiges'],
  'Sicherheit': ['Hauptgebäude', 'Fahrzeughalle', 'Lager', 'Nebengebäude', 'Sonstiges'],
  'Kultur': ['Hauptgebäude', 'Nebengebäude', 'Depot', 'Lager', 'Sonstiges'],
  'Sportstätten': ['Sporthalle', 'Schwimmbad', 'Nebengebäude', 'Umkleiden', 'WC', 'Tribüne', 'Sonstiges'],
  'Soziales': ['Hauptgebäude', 'Nebengebäude', 'Wohnbereich', 'WC', 'Sonstiges'],
  'Medizin': ['Hauptgebäude', 'Nebengebäude', 'Labor', 'Lager', 'Sonstiges'],
  'ÖPNV': ['Hauptgebäude', 'Depot', 'Werkstatt', 'Lager', 'Sonstiges'],
  'Wohnen': ['Wohngebäude', 'Nebengebäude', 'Garage', 'Sonstiges'],
  'Gewerbe': ['Hauptgebäude', 'Lager', 'Werkstatt', 'Garage', 'Sonstiges'],
  'Industrie': ['Produktionshalle', 'Lager', 'Verwaltung', 'Werkstatt', 'Sonstiges'],
  'Infrastruktur': ['Hauptgebäude', 'Technikgebäude', 'Nebengebäude', 'Sonstiges'],
  'Friedhof': ['Kapelle', 'Verwaltung', 'Lager', 'WC', 'Sonstiges'],
  'Sonstiges': ['Hauptgebäude', 'Nebengebäude', 'Sonstiges'],
}

export const DEFAULT_BUILDING_TYPES = ['Hauptgebäude', 'Nebengebäude', 'Sonstiges']

export const HEATING_TYPES = [
  'Gas', 'Fernwärme', 'Wärmepumpe', 'Öl', 'Pellets', 'Elektro', 'Solar', 'Sonstiges'
]
